import React, { useEffect, useState } from "react";
import { Modal, Descriptions, Image } from "antd";
import { getEmployee } from "../../constants/API/API";
import useApi from "../../hooks/useApi";
import moment from "moment";

const EmployeeView = ({ visible, setVisible, id }) => {
  const [employee, setEmployee] = useState(null);

  useApi({
    callback: getEmployee,
    payload: id,
    dependencies: [id],
    shouldCallApi: Boolean(id),
    onSuccess: (data) => {
      setEmployee(data);
    },
  });

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Modal
      open={visible}
      title="Employee Details"
      onCancel={handleCancel}
      footer={null}
      width={700}
      className="tab_modal"
    >
      {employee && (
        <div>
          <div className="text-center mb-4">
            {employee.profilePic && (
              <Image
                src={employee.profilePic}
                alt="Profile"
                style={{ width: 150, height: 150, borderRadius: "50%" }}
              />
            )}
          </div>
          <Descriptions bordered column={1}>
            <Descriptions.Item label="Name">{employee.name}</Descriptions.Item>
            <Descriptions.Item label="Email">
              {employee.email}
            </Descriptions.Item>
            <Descriptions.Item label="Mobile Number">
              {employee.countryCode && `+${employee.countryCode}`}{" "}
              {employee.mobileNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Role">
              {employee.role === "branch"
                ? "Branch Admin"
                : employee.role || employee.roleType || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Branch">
              {employee.branchId?.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Status">
              {employee.isActive ? "Active" : "Inactive"}
            </Descriptions.Item>
            <Descriptions.Item label="Created At">
              {moment(employee.createdAt).format("ll")}
            </Descriptions.Item>
            <Descriptions.Item label="Last Updated">
              {moment(employee.updatedAt).format("ll")}
            </Descriptions.Item>
          </Descriptions>
        </div>
      )}
    </Modal>
  );
};

export default EmployeeView;
